'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import classNames from 'classnames';
import ResultHeader from './ResultHeader';
import ResultInfo from './ResultInfo';
import ResultSection from './ResultSection';
import GradeTypeConstants from '../../constants/GradeTypeConstants';
import Tag from './Tag';
export default class YesNoResultSection extends Component {
  constructor(...args) {
    super(...args);

    this.getTickOrXIconClasses = () => {
      const {
        props
      } = this;
      return classNames("icon", props.gradeType === GradeTypeConstants.GOOD && 'icon-check-circle', props.gradeType === GradeTypeConstants.BAD && 'icon-delete-circle');
    };
  }

  render() {
    const {
      props
    } = this;
    return /*#__PURE__*/_jsxs(ResultSection, {
      gradeType: props.gradeType,
      children: [/*#__PURE__*/_jsx(Tag, Object.assign({}, props)), /*#__PURE__*/_jsx(ResultHeader, Object.assign({}, props)), /*#__PURE__*/_jsx("div", {
        className: this.getTickOrXIconClasses()
      }), /*#__PURE__*/_jsx(ResultInfo, Object.assign({}, props))]
    });
  }

}
YesNoResultSection.propTypes = {
  gradeType: PropTypes.string
};